import { render, staticRenderFns } from "./ConsumerInsights.vue?vue&type=template&id=5a6ad23a&scoped=true&"
import script from "./ConsumerInsights.vue?vue&type=script&lang=js&"
export * from "./ConsumerInsights.vue?vue&type=script&lang=js&"
import style0 from "./ConsumerInsights.vue?vue&type=style&index=0&id=5a6ad23a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6ad23a",
  null
  
)

export default component.exports